import React from "react"
import { HStack, Link } from "@chakra-ui/react"
import { Icon } from "../../"

export default function Social({ data }) {
  return (
    <HStack spacing={6} mb={6} align="center" justify="center">
      {Object.keys(data).map((node, index) => {
        return (
          <Link
            _hover={{ color: "white" }}
            href={`https://www.${data[node]}`}
            display="inline-flex"
            target="_blank"
            key={index}
          >
            <Icon name={node} boxSize={6} />
          </Link>
        )
      })}
    </HStack>
  )
}
